module.exports = __webpack_public_path__ + "media/anema-core.34460083.mp3";